import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4ca5c77e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "help-center-wrapper" }
const _hoisted_2 = { class: "header-bar" }
const _hoisted_3 = { class: "content-wrapper" }
const _hoisted_4 = { class: "menu-bar" }
const _hoisted_5 = { class: "page" }
const _hoisted_6 = { class: "footer-bar" }

import Header from './widgets/Header.vue'
import Footer from './widgets/Footer.vue'
import Sidebar from './widgets/Sidebar.vue'


export default /*#__PURE__*/_defineComponent({
  setup(__props) {


return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(Header)
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createVNode(Sidebar)
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_router_view)
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createVNode(Footer)
    ])
  ]))
}
}

})